// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WalletFilledSvg from "@fishx/icons-svg/es/asn/WalletFilled";
import FishxIcon from '../components/FishxIcon';

var WalletFilled = function WalletFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WalletFilledSvg
  }));
};

WalletFilled.displayName = 'WalletFilled';
export default React.forwardRef(WalletFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WalletFilled.js
// module id = 4375
// module chunks = 0